module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar disabled = false;\nif(!!formMapping && !!formMapping.fieldConfig) {\ndisabled = !!formMapping.fieldConfig.disabled;\n}\nvar fieldConfig = model.config || {};\nvar nrOfElements = model.nrOfElements || 0;\n%>\n<div data-field-code=\"<%- model.fieldCode || '' %>\" class=\"<%- (disabled ? 'disabled' : '') %>\">\n<%\nif(fieldConfig.showSummary !== false){\nif(config.multiSelect){\n%><div class=\"summary\"><%= __('routes.form.picker.summary.multi', { nrOfElements }); %></div><%\n} else if(nrOfElements > 0) {\n%><div class=\"summary\"><%= __('routes.form.picker.summary.single.selected'); %></div><%\n} else {\n%><div class=\"summary\"><%= __('routes.form.picker.summary.single.empty'); %></div><%\n}\n}\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'assign', context: 'routes' } }); %><%\nif((fieldConfig.showExtendedControls || {}).selected !== false){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'assign', mode: 'selected', context: 'routes', symbolOnly: true } }); %><%\n}\nif((fieldConfig.showExtendedControls || {}).reset){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'assign', mode: 'reset', context: 'routes', symbolOnly: true } }); %><%\n}\nif((fieldConfig.showExtendedControls || {}).empty !== false){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'assign', mode: 'empty', context: 'routes', symbolOnly: true } }); %><%\n}\n%>\n</div>"
  , __filename = "node_modules/frontend-controller/baseComponents/form/fields/route-picker-button.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var disabled = false;
if(!!formMapping && !!formMapping.fieldConfig) {
disabled = !!formMapping.fieldConfig.disabled;
}
var fieldConfig = model.config || {};
var nrOfElements = model.nrOfElements || 0;

    ; __line = 8
    ; __append("\n<div data-field-code=\"")
    ; __line = 9
    ; __append( model.fieldCode || '' )
    ; __append("\" class=\"")
    ; __append( (disabled ? 'disabled' : '') )
    ; __append("\">\n")
    ; __line = 10
    ; 
if(fieldConfig.showSummary !== false){
if(config.multiSelect){

    ; __line = 13
    ; __append("<div class=\"summary\">")
    ; __append(escapeFn( __('routes.form.picker.summary.multi', { nrOfElements }) ))
    ; __append("</div>")
    ; 
} else if(nrOfElements > 0) {

    ; __line = 15
    ; __append("<div class=\"summary\">")
    ; __append(escapeFn( __('routes.form.picker.summary.single.selected') ))
    ; __append("</div>")
    ; 
} else {

    ; __line = 17
    ; __append("<div class=\"summary\">")
    ; __append(escapeFn( __('routes.form.picker.summary.single.empty') ))
    ; __append("</div>")
    ; 
}
}

    ; __line = 20
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'assign', context: 'routes' } }) )
    ; 
if((fieldConfig.showExtendedControls || {}).selected !== false){

    ; __line = 22
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'assign', mode: 'selected', context: 'routes', symbolOnly: true } }) )
    ; 
}
if((fieldConfig.showExtendedControls || {}).reset){

    ; __line = 25
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'assign', mode: 'reset', context: 'routes', symbolOnly: true } }) )
    ; 
}
if((fieldConfig.showExtendedControls || {}).empty !== false){

    ; __line = 28
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'assign', mode: 'empty', context: 'routes', symbolOnly: true } }) )
    ; 
}

    ; __line = 30
    ; __append("\n</div>")
    ; __line = 31
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/form/fields/route-picker-button.ejs

}